<section class="inner-page">
    <div class="container tofupadding">
        <img src="assets/img/logo-admincourt.png" alt="logo" class="image-center" style="width: 170px;">
        <h1 class="text-center">นโยบายการคุ้มครองข้อมูลส่วนบุคคล</h1>
        <div class="d-none d-md-block">
            <!-- <h1 class="text-center text-red">TERMS OF USE</h1> -->
            <!-- <h4 class="set-text margin-top-10">{{'TERMS_OF_USE_1'|translate}}</h4> -->
            <h4 class="set-text-head margin-top-10">1. ข้อมูลส่วนบุคคล</h4>
            <h4 class="set-text ">1.1 ผู้ให้บริการอาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากขั้นตอนการใช้บริการ ดังนี้
                การลงทะเบียนหรือการสมัครใช้บริการต่าง ๆ กับทางแอปพลิเคชัน “ศาลปกครอง” (e-Litigation,  e-Admincourt)
                ในการทำแบบสอบถาม (Survey) หรือการโต้ตอบทาง e-mail หรือช่องทางการสื่อสารอื่น ๆ ระหว่างเราและท่าน</h4>

            <h4 class="set-text">1.2 ข้อมูลส่วนบุคคลที่เก็บรวบรวม ได้แก่
                ข้อมูลส่วนตัว เช่น ชื่อ นามสกุล หมายเลขบัตรประชาชน ที่อยู่
                ข้อมูลส่วนบุคคลอื่น ซึ่งระบบจะขอความยินยอมจากท่านก่อน</h4>
            <h4 class="set-text-head">2. การรักษาความปลอดภัยของข้อมูลส่วนบุคคล</h4>
            <h4 class="set-text"> 2.1 เราจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่าน เว้นแต่เป็นการเปิดเผยข้อมูลตามความจำเป็น
                เนื่องจากกระทำตามกฎหมาย, คำสั่ง, กฎ, ข้อบังคับ, คำสั่งศาล, หรือหน่วยงานของรัฐ
                หรือได้รับความยินยอมจากท่าน</h4>
            <h4 class="set-text">2.2 เราใช้ Secure Socket Layer (SSL)
                ซึ่งเป็นมาตรฐานการรักษาความปลอดภัยของข้อมูลที่รับส่งผ่านอินเทอร์เน็ต รวมถึงมีการเข้ารหัสและจัดตั้ง
                Firewall โดย Secured Socket Layer (SSL) เป็นเทคโนโลยี ในการเข้าสู่ข้อมูลผ่านรหัส
                เพื่อป้องกันผู้ที่แอบดักจับข้อมูลขณะที่มีการส่งผ่านเครือข่ายอินเทอร์เน็ต</h4>
            <h4 class="set-text-head">3. การประมวลผลข้อมูล</h4>
            <h4 class="set-text">3.1 เราจะใช้ข้อมูลส่วนบุคคลเพื่อการติดต่อสื่อสารที่เกี่ยวข้องกับบริการของระบบ
                รวมถึงสิทธิประโยชน์ ที่เกี่ยวข้องกับบริการดังกล่าว</h4>
            <h4 class="set-text">3.2 เราจะใช้ข้อมูลส่วนบุคคลเพื่อการแก้ไข ปรับปรุงประสิทธิภาพการทำงานของระบบ
                วิเคราะห์ข้อมูลการใช้บริการ
                ประเมินการบริการ รวมถึงการปรับปรุงการบริการของผู้ให้บริการ</h4>
            <h4 class="set-text-head">4. สิทธิของเจ้าของข้อมูล</h4>
            <h4 class="set-text">4.1 ผู้ใช้งานระบบมีสิทธิในการดำเนินการในฐานะเจ้าของข้อมูล ดังต่อไปนี้
                สิทธิในการเพิกถอนความยินยอม (right to withdraw consent):
                ท่านมีสิทธิในการเพิกถอนความยินยอม ในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับเราได้ตลอดระยะเวลาที่ข้อมูลส่วนบุคคล ของท่านอยู่กับเรา
                เว้นแต่มีข้อจำกัดสิทธิที่ห้ามมิให้ถอนความยินยอมโดยระบุไว้ในกฎหมายหรือในสัญญา ที่ให้ประโยชน์แก่ท่าน
                สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (right of access):
                ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านและขอให้เราทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน
                รวมถึงขอให้เราเปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคล ที่ท่านไม่ได้ให้ความยินยอมต่อเราได้
                สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (right to rectification):
                ท่านมีสิทธิในการขอให้เราแก้ไขข้อมูล ที่ไม่ถูกต้อง หรือ เพิ่มเติมข้อมูลที่ไม่สมบูรณ์
                สิทธิในการลบข้อมูลส่วนบุคคล (right to erasure):
                ท่านมีสิทธิในการขอให้เราลบข้อมูลของท่านด้วยเหตุ บางประการได้
                สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (right to restriction of processing):
                ท่านมีสิทธิในการระงับการใช้ข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้
                สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (right to object):
                ท่านมีสิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้</h4>
            <h4 class="set-text">4.2 ผู้ใช้งานระบบสามารถติดต่อมายังผู้ดูแลระบบได้ ตามช่องทางการติดต่อที่ได้จัดไว้ให้
                เพื่อดำเนินการยื่นคำร้องขอดำเนินการตามสิทธิข้างต้น</h4>
            <h4 class="set-text-head">
                5. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
                เราจะพิจารณาทบทวนนโยบายความเป็นส่วนตัวเป็นประจำเพื่อให้สอดคล้องกับแนวปฏิบัติและกฎหมาย
                ข้อบังคับที่เกี่ยวข้อง ทั้งนี้ หากมีการเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
                เราจะแจ้งให้ท่านทราบด้วยการปรับปรุงขอมูลลงบนแอปพลิเคชัน
                ปัจจุบันนโยบายความเป็นส่วนตัวถูกทบทวนครั้งล่าสุดเมื่อวันที่  15 มกราคม 2564 </h4>

        </div>
        <div class="d-md-none">
            <!-- <h2 class="text-center text-red">TERMS OF USE</h2> -->
            <!-- <p class="set-text margin-top-10">{{'TERMS_OF_USE_1'|translate}}</p> -->
            <p class="set-text-head margin-top-10">1. ข้อมูลส่วนบุคคล</p>
            <p class="set-text ">1.1 ผู้ให้บริการอาจเก็บรวบรวมข้อมูลส่วนบุคคลของท่านจากขั้นตอนการใช้บริการ ดังนี้
                การลงทะเบียนหรือการสมัครใช้บริการต่าง ๆ กับทางแอปพลิเคชัน “ศาลปกครอง” (e-Litigation,  e-Admincourt)
                ในการทำแบบสอบถาม (Survey) หรือการโต้ตอบทาง e-mail หรือช่องทางการสื่อสารอื่น ๆ ระหว่างเราและท่าน</p>

            <p class="set-text">1.2 ข้อมูลส่วนบุคคลที่เก็บรวบรวม ได้แก่
                ข้อมูลส่วนตัว เช่น ชื่อ นามสกุล หมายเลขบัตรประชาชน ที่อยู่
                ข้อมูลส่วนบุคคลอื่น ซึ่งระบบจะขอความยินยอมจากท่านก่อน</p>
            <p class="set-text-head">2. การรักษาความปลอดภัยของข้อมูลส่วนบุคคล</p>
            <p class="set-text"> 2.1 เราจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่าน เว้นแต่เป็นการเปิดเผยข้อมูลตามความจำเป็น
                เนื่องจากกระทำตามกฎหมาย, คำสั่ง, กฎ, ข้อบังคับ, คำสั่งศาล, หรือหน่วยงานของรัฐ
                หรือได้รับความยินยอมจากท่าน</p>
            <p class="set-text">2.2 เราใช้ Secure Socket Layer (SSL)
                ซึ่งเป็นมาตรฐานการรักษาความปลอดภัยของข้อมูลที่รับส่งผ่านอินเทอร์เน็ต รวมถึงมีการเข้ารหัสและจัดตั้ง
                Firewall โดย Secured Socket Layer (SSL) เป็นเทคโนโลยี ในการเข้าสู่ข้อมูลผ่านรหัส
                เพื่อป้องกันผู้ที่แอบดักจับข้อมูลขณะที่มีการส่งผ่านเครือข่ายอินเทอร์เน็ต</p>
            <p class="set-text-head">3. การประมวลผลข้อมูล</p>
            <p class="set-text">3.1 เราจะใช้ข้อมูลส่วนบุคคลเพื่อการติดต่อสื่อสารที่เกี่ยวข้องกับบริการของระบบ
                รวมถึงสิทธิประโยชน์ ที่เกี่ยวข้องกับบริการดังกล่าว</p>
            <p class="set-text">3.2 เราจะใช้ข้อมูลส่วนบุคคลเพื่อการแก้ไข ปรับปรุงประสิทธิภาพการทำงานของระบบ
                วิเคราะห์ข้อมูลการใช้บริการ
                ประเมินการบริการ รวมถึงการปรับปรุงการบริการของผู้ให้บริการ</p>
            <p class="set-text-head">4. สิทธิของเจ้าของข้อมูล</p>
            <p class="set-text">4.1 ผู้ใช้งานระบบมีสิทธิในการดำเนินการในฐานะเจ้าของข้อมูล ดังต่อไปนี้
                สิทธิในการเพิกถอนความยินยอม (right to withdraw consent):
                ท่านมีสิทธิในการเพิกถอนความยินยอม ในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับเราได้ตลอดระยะเวลาที่ข้อมูลส่วนบุคคล ของท่านอยู่กับเรา
                เว้นแต่มีข้อจำกัดสิทธิที่ห้ามมิให้ถอนความยินยอมโดยระบุไว้ในกฎหมายหรือในสัญญา ที่ให้ประโยชน์แก่ท่าน
                สิทธิในการเข้าถึงข้อมูลส่วนบุคคล (right of access):
                ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านและขอให้เราทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน
                รวมถึงขอให้เราเปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคล ที่ท่านไม่ได้ให้ความยินยอมต่อเราได้
                สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง (right to rectification):
                ท่านมีสิทธิในการขอให้เราแก้ไขข้อมูล ที่ไม่ถูกต้อง หรือ เพิ่มเติมข้อมูลที่ไม่สมบูรณ์
                สิทธิในการลบข้อมูลส่วนบุคคล (right to erasure):
                ท่านมีสิทธิในการขอให้เราลบข้อมูลของท่านด้วยเหตุ บางประการได้
                สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล (right to restriction of processing):
                ท่านมีสิทธิในการระงับการใช้ข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้
                สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล (right to object):
                ท่านมีสิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่านด้วยเหตุบางประการได้</p>
            <p class="set-text">4.2 ผู้ใช้งานระบบสามารถติดต่อมายังผู้ดูแลระบบได้ ตามช่องทางการติดต่อที่ได้จัดไว้ให้
                เพื่อดำเนินการยื่นคำร้องขอดำเนินการตามสิทธิข้างต้น</p>
            <p class="set-text-head">
                5. การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
                เราจะพิจารณาทบทวนนโยบายความเป็นส่วนตัวเป็นประจำเพื่อให้สอดคล้องกับแนวปฏิบัติและกฎหมาย
                ข้อบังคับที่เกี่ยวข้อง ทั้งนี้ หากมีการเปลี่ยนแปลงนโยบายความเป็นส่วนตัว
                เราจะแจ้งให้ท่านทราบด้วยการปรับปรุงขอมูลลงบนแอปพลิเคชัน
                ปัจจุบันนโยบายความเป็นส่วนตัวถูกทบทวนครั้งล่าสุดเมื่อวันที่  15 มกราคม 2564 </p>
        </div>
        <!-- <br> -->
        <hr style="    margin-left: 30%;
        margin-right: 30%;">

    </div>
</section>